import {
  SET_PAYOUT_START,
  SET_PAYOUT_SUCCESS,
  SET_PAYOUT_ERROR,
  UPDATE_PAYMENT_STATUS_START,
  UPDATE_PAYMENT_STATUS_SUCCESS,
  UPDATE_PAYMENT_STATUS_ERROR
} from '../../../constants';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import {
  updatePayoutMutation, getPayoutListQuery, updatePaymentMutation,
  getPaymentMethodsQuery
} from '../../../lib/graphql';

const updatePayoutStatus = (id, isBanStatus) => {

  return async (dispatch, getState, { client }) => {

    try {

      dispatch({
        type: SET_PAYOUT_START,
      });

      const { data } = await client.mutate({
        mutation: updatePayoutMutation,
        variables: { id, isBanStatus },
        refetchQueries: [{ query: getPayoutListQuery, variables: { currentPage: '1', searchList: '' } }]
      });

      if (data?.updatePayout?.status === 200) {

        dispatch({
          type: SET_PAYOUT_SUCCESS,
        });

        showToaster({ messageId: 'updatePayout', toasterType: 'success' });

      } else {

        dispatch({
          type: SET_PAYOUT_ERROR,
          payload: {
            error
          }
        });

        showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updatePayout?.errorMessage }, toasterType: 'error' });
        return false;
      }
    } catch (error) {

      dispatch({
        type: SET_PAYOUT_ERROR,
        payload: {
          error
        }
      });

      showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });

      return false;
    }
    return true;
  };
}

const updatePaymentMethod = (id, status) => {

  return async (dispatch, getState, { client }) => {

    try {

      dispatch({
        type: UPDATE_PAYMENT_STATUS_START,
      });

      const { data } = await client.mutate({
        mutation: updatePaymentMutation,
        variables: { id, status },
        refetchQueries: [{ query: getPaymentMethodsQuery }]
      });
      if (data?.updatePayment?.status === 200) {
        dispatch({
          type: UPDATE_PAYMENT_STATUS_SUCCESS,
        });
        showToaster({ messageId: 'updatePayment', toasterType: 'success' })
      } else {
        dispatch({
          type: UPDATE_PAYMENT_STATUS_ERROR,
          payload: {
            error: data?.updatePayment?.errorMessage
          }
        });
        showToaster({ messageId: 'failedStatus', requestContent: { content: data?.updatePayment?.errorMessage }, toasterType: 'error' });
        return false;
      }
    } catch (error) {
      dispatch({
        type: UPDATE_PAYMENT_STATUS_ERROR,
        payload: {
          error
        }
      });
      showToaster({ messageId: 'updatePaymentError', toasterType: 'error' })
      return false;
    }
    return true;
  };
}

export {
  updatePayoutStatus,
  updatePaymentMethod
};